import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) return;
    // Use requestAnimationFrame to ensure DOM has updated
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [location.pathname, location.hash]);

  return children;
};

export { ScrollToTop };
